// 회사 자동완성 기능 숨김처리로 인해 드롭다운 리스트 표출되도록 하기 위해 주석 처리 진행
export const AUTO_COMPANY_SHELL: string[] = [
  // "Authorized Company",
  // "Licensor Name",
  // "Licensee Name",
  // "Originator/Developer",
];
